import { render, staticRenderFns } from "./ScrollShow.vue?vue&type=template&id=554965f6"
import script from "./ScrollShow.vue?vue&type=script&lang=js"
export * from "./ScrollShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports